import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

const initialState = {
  status: null,
  data: null
};

export const getFilterData = createAsyncThunk(
  "getFilterData",
  async (data) => {
    try {
      const response = await fetch(`/api/getFiltersData/${data.configId}/${data.locale}`, {
        method: "GET",
        cache: "no-store",
      });
      if (!response.ok) {
        throw new Error("Failed to fetch config");
      }
      return await response.json();
    } catch (error) {
      throw new Error(error.message);
    }
  }
);

const credentialsSlice = createSlice({
  name: "getFilterData",
  initialState,
  extraReducers: (builder) => {
    builder
      .addCase(getFilterData.pending, (state) => {
        state.status = "PIM loading";
        state.message = null;
      })
      .addCase(getFilterData.fulfilled, (state, action) => {
        state.status = "PIM loaded";
        state.data = action.payload.data.data;
      })
      .addCase(getFilterData.rejected, (state, action) => {
        state.status = "error";
        state.message = action.error.message;
      });
  },
});

export default credentialsSlice.reducer;
